if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",
          select: "select",
        };
        this.hasCustomFields = !!document.querySelector(".m-main-product--info .m-product-custom-field");
      }

      connectedCallback() {
        this.mainProduct = document.querySelector("product-info[id^='MainProduct']");
        this.container = this.closest(".m-sticky-addtocart");
        this.mainProductForm = document.querySelector(".m-product-form--main");
        this.mainProductInfo = document.querySelector(".m-main-product--info");
        this.mainAddToCart = this.mainProductForm ? this.mainProductForm.querySelector(".m-add-to-cart") : null;
        this.mainDynamicCheckout = this.mainProductForm ? this.mainProductForm.querySelector(this.selectors.buyNowBtn) : null;
        this.disableSelectedVariantDefault = this.mainProduct && this.mainProduct.dataset.disableSelectedVariantDefault === "true";
        this.domNodes = queryDomNodes(this.selectors, this.container);

        this.init();
      }

      getMainAddToCart() {
        if (!this.mainAddToCart || !this.mainAddToCart.isConnected) {
          this.mainProductForm = document.querySelector(".m-product-form--main") || document.querySelector(".m-product-form");
          this.mainAddToCart = this.mainProductForm ? this.mainProductForm.querySelector(".m-add-to-cart, button[name='add']") : document.querySelector("button[name='add']");
        }
        return this.mainAddToCart;
      }

      getMainPurchaseTrigger() {
        this.mainProductForm = document.querySelector(".m-product-form--main") || document.querySelector(".m-main-product--info form") || document.querySelector(".m-product-form");
        if (!this.mainProductForm) return document.querySelector("button[name='add']");
        
        // Check for dynamic checkout button ("COMPRAR AHORA" / Shopify payment button)
        const dynamicCheckout = this.mainProductForm.querySelector(".m-product-dynamic-checkout, .shopify-payment-button, .shopify-payment-button__button, [data-testid='Checkout-button']");
        if (dynamicCheckout && dynamicCheckout.offsetHeight > 0 && dynamicCheckout.offsetParent !== null) {
          return dynamicCheckout;
        }

        // Fallback to main add to cart button
        return this.mainProductForm.querySelector(".m-add-to-cart, button[name='add']") || this.mainProductForm;
      }

      init() {
        this.variantData = this.getVariantData();

        let isFooterVisible = false;

        // Robust scroll & intersection trigger
        const showStickyBar = () => {
          if (this.container && !isFooterVisible) {
            this.container.classList.add("stick-atc-show");
            this.container.setAttribute("data-show", "true");
            this.container.style.setProperty("--m-translate-y", "0%");
            this.container.style.transform = "translate3d(0, 0, 0)";
            this.container.style.opacity = "1";
            this.container.style.visibility = "visible";
            document.documentElement.classList.add("stick-atc-show");
          }
        };

        const hideStickyBar = () => {
          if (this.container) {
            this.container.classList.remove("stick-atc-show");
            this.container.removeAttribute("data-show");
            this.container.style.setProperty("--m-translate-y", "150%");
            this.container.style.transform = "translate3d(0, calc(100% + 60px), 0)";
            this.container.style.opacity = "0";
            this.container.style.visibility = "hidden";
            document.documentElement.classList.remove("stick-atc-show");
          }
        };

        const isTriggerPassed = () => {
          const trigger = this.getMainPurchaseTrigger();
          if (!trigger) return false;
          const rect = trigger.getBoundingClientRect();
          // The trigger has completely left the visible screen when its bottom <= 0
          return rect.bottom <= 0;
        };

        const checkStickyState = () => {
          if (isTriggerPassed() && !isFooterVisible) {
            showStickyBar();
          } else {
            hideStickyBar();
          }
        };

        const target = this.getMainPurchaseTrigger();
        if (target && "IntersectionObserver" in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting && entry.boundingClientRect.bottom <= 0) {
                  showStickyBar();
                } else {
                  hideStickyBar();
                }
              });
            },
            { threshold: 0, rootMargin: "0px 0px 0px 0px" }
          );
          this.observer.observe(target);
        }

        // Secondary fallback window scroll listener
        const handleScroll = () => {
          checkStickyState();
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        checkStickyState();

        // Footer observer: hide sticky bar when footer enters viewport
        const footerEl = document.querySelector('#shopify-section-footer, .m-footer, footer.site-footer');
        if (footerEl && "IntersectionObserver" in window) {
          this.footerObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                isFooterVisible = entry.isIntersecting;
                if (isFooterVisible) {
                  hideStickyBar();
                } else {
                  checkStickyState();
                }
              });
            },
            { threshold: 0, rootMargin: "0px 0px 20px 0px" }
          );
          this.footerObserver.observe(footerEl);
        }

        if (this.disableSelectedVariantDefault) {
          this.handleDisableSelectedVariantDefault();
        }

        const { prodTitle, mainImage } = this.domNodes;
        if (prodTitle) prodTitle.addEventListener("click", () => typeof __scrollToTop === 'function' ? __scrollToTop() : window.scrollTo({ top: 0, behavior: 'smooth' }));
        if (mainImage) mainImage.addEventListener("click", () => typeof __scrollToTop === 'function' ? __scrollToTop() : window.scrollTo({ top: 0, behavior: 'smooth' }));

        this.handleCustomFields();
        this.syncWithMainProductForm();

        const mql = window.matchMedia(MinimogTheme.config ? MinimogTheme.config.mediaQueryMobile : '(max-width: 767px)');
        mql.onchange = this.setStickyAddToCartHeight.bind(this);
        this.setStickyAddToCartHeight();

        if (this.domNodes.select) {
          this.domNodes.select.addEventListener("change", (e) => {
            const { target } = e;
            const variantPicker = this.mainProduct ? this.mainProduct.querySelector('variant-picker') : null;
            const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
            this.currentVariant = this.variantData ? this.variantData.find((variant) => variant.id === Number(selectedVariantId)) : null;
            this.currentVariant ? this.toggleAddButton(!this.currentVariant.available, window.MinimogStrings.soldOut) : this.toggleAddButton(true, window.MinimogStrings.unavailable);

            const selectedOption = target.options[target.selectedIndex];
            const selectedOptionIds = selectedOption && selectedOption.dataset.options ? selectedOption.dataset.options.split(',').filter(id => id) : [];

            if (variantPicker) {
              selectedOptionIds.forEach((optionId) => {
                const input = variantPicker.querySelector(`[data-option-value-id="${optionId}"]`);
                if (input) {
                  const { tagName } = input;
                  switch (tagName) {
                    case "OPTION":
                      const inputParent = input.parentNode;
                      inputParent.value = input.value;
                      break;
                    case "INPUT":
                      input.checked = true;
                      break;
                  }
                }
              });
              variantPicker.dispatchEvent(new Event("change"));
            }
          });
        }
      }

      getVariantData() {
        try {
          const jsonEl = this.container.querySelector('[type="application/json"]');
          this.variantData = this.variantData || (jsonEl ? JSON.parse(jsonEl.textContent) : []);
        } catch (err) {
          this.variantData = [];
        }
        return this.variantData;
      }

      setUnavailable() {
        const productForm = this.querySelector('.m-product-form');
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        if (addButton) {
          this.toggleAddButton(true, window.MinimogStrings ? window.MinimogStrings.unavailable : 'Agotado');
        }
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('.m-product-form');
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span.m-add-to-cart--text');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text && addButtonText) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          if (addButtonText) addButtonText.innerHTML = window.MinimogStrings ? window.MinimogStrings.addToCart : 'Agregar al carrito';
        }
      }

      handleDisableSelectedVariantDefault() {
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("variant")) return;

        const pickerFields = this.querySelector('.m-product-option--dropdown-select');
        if (pickerFields) {
          pickerFields.value = '';
          this.setUnavailable();
        }
      }

      setStickyAddToCartHeight() {
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", this.offsetHeight + "px");
        if (window.MinimogSettings) {
          window.MinimogSettings.stickyAddToCartHeight = this.offsetHeight;
        }
      }

      syncWithMainProductForm() {
        const variantInput = this.querySelector('[name="id"]');
        const sizeEl = this.querySelector('[data-sticky-size]');
        const priceEl = this.querySelector('[data-sticky-price]');
        const comparePriceEl = this.querySelector('[data-sticky-compare-price]');
        if (!variantInput || !window.MinimogEvents || !window.MinimogTheme) return;
        MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, (e) => {
          const isMainProduct = this.mainProduct && e.data.sectionId === this.mainProduct.dataset.sectionId;
          if (!isMainProduct) return;
          this.currentVariant = e.data.variant;
          if (this.currentVariant) {
            variantInput.value = e.data.variant.id;
            this.toggleAddButton(!this.currentVariant.available, window.MinimogStrings ? window.MinimogStrings.soldOut : 'Agotado');
            if (sizeEl && this.currentVariant.title && this.currentVariant.title !== 'Default Title') {
              sizeEl.textContent = 'Talla ' + this.currentVariant.title;
            }
            if (priceEl && typeof formatMoney === 'function') {
              priceEl.innerHTML = formatMoney(this.currentVariant.price, window.MinimogSettings ? window.MinimogSettings.money_format : '$ {{amount}}');
            }
            if (comparePriceEl) {
              if (this.currentVariant.compare_at_price > this.currentVariant.price && typeof formatMoney === 'function') {
                comparePriceEl.innerHTML = formatMoney(this.currentVariant.compare_at_price, window.MinimogSettings ? window.MinimogSettings.money_format : '$ {{amount}}');
                comparePriceEl.style.display = 'inline';
              } else {
                comparePriceEl.style.display = 'none';
              }
            }
          } else {
            variantInput.value = '';
            this.toggleAddButton(true, window.MinimogStrings ? window.MinimogStrings.unavailable : 'No disponible');
          }
        });
      }

      handleCustomFields() {
        if (!this.hasCustomFields) return;
        const { addToCart, buyNowBtn, foxkitBtn } = this.domNodes;
        let hasCustomFieldRequired = false;
        const customFields = document.querySelectorAll(".m-main-product--info .m-product-custom-field");
        customFields &&
          customFields.forEach((item) => {
            const field = item.querySelector(".form-field");
            if (field && field.value == "" && field.hasAttribute("required")) {
              hasCustomFieldRequired = true;
            }
          });

        if (hasCustomFieldRequired && addToCart) {
          addToCart.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (typeof __scrollToTop === 'function') {
              __scrollToTop(this.mainProductInfo, () => this.mainAddToCart && this.mainAddToCart.click());
            }
          });
        }
        if (buyNowBtn) {
          buyNowBtn.addEventListener(
            "click",
            (e) => {
              const missing = typeof validateForm === 'function' ? validateForm(this.mainProductInfo) : [];
              if (missing.length > 0) {
                e.preventDefault();
                e.stopPropagation();
                if (typeof __scrollToTop === 'function') {
                  __scrollToTop(this.mainProductInfo, () => this.mainDynamicCheckout && this.mainDynamicCheckout.click());
                }
              }
            },
            true
          );
        }
        if (foxkitBtn) {
          foxkitBtn.addEventListener("click", (e) => {
            e.preventDefault();
            if (typeof __scrollToTop === 'function') {
              __scrollToTop(this.mainProductInfo, () => this.mainAddToCart && this.mainAddToCart.click());
            }
          });
        }
      }
    }
  );
}